/* unplugin-vue-components disabled */
export default {
  props: {
    content: {
      type: String,
      default: 'Copied to clipboard'
    },
    placement: {
      type: String,
      default: 'top'
    },
    effect: {
      type: String,
      default: 'light'
    }
  },
  emits: ['copy'],
  data() {
    return {
      show_tip: false,
    }
  },
  methods: {
    async copy() {
      this.$emit('copy')
      this.show_tip = true
      await $utils.timers.wait(2000)
      this.show_tip = false
    },
  }
}
